import React,{useState,useEffect} from "react";
import SubHeader from "../../layout/components/SubHeader";
import { useSurveyStore } from '../../helpers/ecxsurvey/surveyutilities/surveyStore';
import { useNavigate } from 'react-router-dom';

const SurveyPublishPage = () => {

    const exportToJSON = useSurveyStore((state)=>state.exportToJSON);
    const [surveyJson,setSurveyJson] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Export survey JSON only once when component mounts
        const survey = exportToJSON();
        setSurveyJson(survey);
        //console.log(survey);
    }, [exportToJSON]); // ✅ Dependency array ensures effect runs once

    const handeEditSurvey=()=>{
        navigate('/surveys/create-survey');
    }

    return (
        <>
            <SubHeader title="Publish Survey" description={"Choose how you want to share your survey with respondents"}>
                <div className="d-flex justify-content-end gap-1">
                    <button className="btn btn-info btn-lg shadow-sm text-white" onClick={handeEditSurvey} >
                        <i className="bi bi-pencil-square me-2"></i>Edit
                    </button>
                    <button className="btn btn-success btn-lg shadow-sm text-white" >
                        <i className="bi bi-send-fill me-2"></i>Publish
                    </button>
                </div>
            </SubHeader>
            <div className="container my-4">

                <div className="row">
                    <div className="col-12">
                        <div className="card shadow-sm mb-3 text-white pt-4" style={{
                            background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                            border: 'none',
                            borderRadius: '0.75rem',
                        }}>
                            <div className="card-body">
                                <div className="row align-items-center">
                                    {/* Left side: Survey Name & Description */}
                                    <div className="col-md-6 mb-2 mb-md-0">
                                        <h5 className="mb-2 text-white">
                                            <strong>Survey Name:</strong> {surveyJson?.survey?.title || "N/A"}
                                        </h5>
                                        <h6 className="mb-0 text-white-50">
                                            <strong>Description:</strong> {surveyJson?.survey?.description || "N/A"}
                                        </h6>
                                    </div>

                                    {/* Right side: Total Questions & Last Modified */}
                                    <div className="col-md-6 text-md-end">
                                        <p className="mb-1 text-white">
                                            <strong>Total Questions:</strong> {surveyJson?.questions?.length || 0}
                                        </p>
                                        <p className="mb-0 text-white">
                                            <strong>Last Modified:</strong> {surveyJson?.survey?.updatedAt || "N/A"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-3">
                    {/* Left Sidebar: Filters & Search */}
                    <div className="col-lg-3 col-md-4">
                        <div className="card shadow-sm mb-3">
                            <div className="card-body">
                                <h5 className="card-title mb-3">Filter Patients</h5>

                                {/* Patient Search */}
                                <div className="mb-3">
                                    <label className="form-label">Search Patient</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white"><i className="bi bi-search"></i></span>
                                        <input type="text" className="form-control" placeholder="Search by name" />
                                        <button className="btn btn-outline-secondary" type="button">
                                            <i className="bi bi-x-lg"></i>
                                        </button>
                                    </div>
                                </div>

                                {/* Age Range */}
                                <div className="mb-3">
                                    <label className="form-label">Age Range</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input type="number" className="form-control" placeholder="Min" />
                                        <span>–</span>
                                        <input type="number" className="form-control" placeholder="Max" />
                                    </div>
                                </div>

                                {/* Gender */}
                                <div className="mb-3">
                                    <label className="form-label">Gender</label>
                                    <select className="form-select">
                                        <option value="">All</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                {/* Doctor */}
                                <div className="mb-3">
                                    <label className="form-label">Doctor</label>
                                    <select className="form-select">
                                        <option value="">All Doctors</option>
                                        <option value="dr1">Dr. Smith</option>
                                        <option value="dr2">Dr. Patel</option>
                                    </select>
                                </div>

                                {/* Appointment Filter */}
                                <div className="mb-3">
                                    <label className="form-label">Appointment</label>

                                    <div className="d-flex gap-2">
                                        <input type="date" className="form-control" />
                                        <input type="date" className="form-control" />
                                    </div>
                                </div>

                                {/* Reset & Search */}
                                <div className="d-flex gap-2 justify-content-end mt-3">
                                    <button className="btn btn-outline-danger btn-sm"><i className="bi bi-arrow-counterclockwise me-1"></i>Reset</button>
                                    <button className="btn btn-primary text-white btn-sm"><i className="bi bi-search me-1"></i>Search</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Patient Table */}
                    <div className="col-lg-9 col-md-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title mb-3">Select Patients</h5>
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle">
                                        <thead className="table-light">
                                        <tr>
                                            <th scope="col">
                                                <input type="checkbox" />
                                            </th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Age</th>
                                            <th scope="col">Gender</th>
                                            <th scope="col">Doctor</th>
                                            <th scope="col">Appointment Date</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td><input type="checkbox" /></td>
                                            <td>John Doe</td>
                                            <td>34</td>
                                            <td>Male</td>
                                            <td>Dr. Smith</td>
                                            <td>2025-10-11</td>
                                        </tr>
                                        <tr>
                                            <td><input type="checkbox" /></td>
                                            <td>Jane Smith</td>
                                            <td>29</td>
                                            <td>Female</td>
                                            <td>Dr. Patel</td>
                                            <td>2025-10-11</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination & selected count */}
                                <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                                    <div>
                                        <strong>2</strong> patients selected
                                    </div>
                                    <nav>
                                        <ul className="pagination pagination-sm mb-0">
                                            <li className="page-item disabled"><button className="page-link">Prev</button></li>
                                            <li className="page-item active"><button className="page-link">1</button></li>
                                            <li className="page-item"><button className="page-link">2</button></li>
                                            <li className="page-item"><button className="page-link">Next</button></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SurveyPublishPage;
